import { useState, useEffect } from "react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "./dashboard.css";
import "bootstrap/dist/css/bootstrap.min.css";
import httpService from "../../../services/http.service";
import { Button, Table } from "reactstrap";
import { useHistory, useLocation } from "react-router-dom";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Loader from "../../common/loader";
import SuccessMessage from "../../../components/common/successMsg";
import WarningMessage from "../../../components/common/warnMsg";
import ErrorMessage from "../../../components/common/errorMsg";
import CommonUtils from "../../common/commonUtiles";
import Swal from 'sweetalert2'
import { faPlusSquare, } from "@fortawesome/free-solid-svg-icons";
import iconImage from "../../../assets/download.jpg";
import validator from 'validator';
import ChannelStats from "../channelstats";
// new design ----
import { cloudLicenceNo, cloudLicenceNoused } from "../../authentication/encryptanddecrypted/encryptAndDecrypt";
// import { CHECK_KEYLOK } from "../../../config";

let CloudDashboard = (props) => {
  const [alldata, setAlldata] = useState([]);
  const [allRuledata, setAllRuledata] = useState([]);
  const [allRuledataTest, setAllRuledataTest] = useState([]);
  const [allProperty, setAllProperty] = useState([]);
  const [LayoutArray, setlayoutArray] = useState([]);
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [showRule, setShowRule] = useState(false);
  const [show2, setShow2] = useState(false);
  const [show3, setShow3] = useState(false);
  const [save, setSave] = useState(false);
  const [save1, setSave1] = useState(false);
  const [save3, setSave3] = useState(false);
  const [array1, setArray1] = useState([]);
  const [array2, setArray2] = useState([]);
  const [array3, setArray3] = useState([]);
  const [propertyToggle, setpropertyToggle] = useState({});
  const [show1, setShow1] = useState(false);
  const [onClickData, setOnclickData] = useState({});
  const [IPFormatDataValue, setIPFormatDataValue] = useState([]);
  const [IPFormatV, setIPFormatV] = useState([]);
  const [IPFormatVal, setIPFormatVal] = useState([]);
  const [IPFormatData, setIPFormatData] = useState([]);
  const [onClickDelete, setOnclickDelete] = useState('');
  const [onClickRuleData, setOnclickRuleData] = useState({});
  const [onClickProperty, setOnclickProperty] = useState({});
  const [selectedValue, setSelectedValue] = useState("");
  const [allDataArr, setAllDataArr] = useState({});
  const [dataStats, setdataStats] = useState({});
  const [PropertyDataObject, setPropertyDataObject] = useState({});
  const [dummyPropertyDataObject, setdummyPropertyDataObject] = useState({});
  const [ruleDelete, setRuleDelete] = useState(false);
  const [activeClass, setActiveClass] = useState("");
  const [channelRuleExisting, setchannelRuleExisting] = useState("");
  const [ruleForProperty, setRuleForProperty] = useState("");
  const [channelIdforRule, setchannelIdforRule] = useState("");
  const [channelRuleName, setchannelRuleName] = useState("");
  const [hideProperty, setHideProperty] = useState(true)
  // const [hide, sethide] = useState(true)
  const [ipAddressPlaceHolder, setIpAddressPlaceHolder] = useState('255.255.255.0')
  const [onClickAddAndEditMsg, setOnClickAddAndEditMsg] = useState("Add");
  const [ipAddressNote, setIpAddressNote] = useState('')
  const [defaultVal, setDefaultVal] = useState([]);
  const [selectedPropertyValues, setSelectedPropertyValues] = useState([]);
  const [propertyVal, setPropertyVal] = useState([]);
  const [selectedRuleValues, setSelectedRuleValues] = useState([]);

  const [ruleSecledValue, setRuleSecledValue] = useState([]);
  const [warningMsg, setWarningMsg] = useState([]);
  const [warningMsgToggle, setWarningMsgToggle] = useState(true);
  // new design ---
  const [usedPropertyLicences, setUsedPropertyLicences] = useState({})
  const history = useHistory();
  const location = useLocation();

  const userRole = localStorage.getItem("CloudUserType")





  const getLicensedProperty = async () => {
    try {
      let propertyCount = await cloudLicenceNo();
      // new design---
      let l = await cloudLicenceNoused()
      console.log(l, "propertyCount")
      // console.log(params.data,"asdfghjkl")

      setUsedPropertyLicences(l)
      setHideProperty(propertyCount)

    } catch (error) {

    }
  }

  useEffect(() => {
    if (!props.verifyTokenUser && history.location.pathname != '/cloudlogin') history.push('/cloudlogin')
  }, [props.verifyTokenUser])

  let BillboardIdList = [];
  var rulearray = ["IpAddress", "MacAddress", "AccountNumber", "Geo_Location"];
  const ruleSelectValues = [
    { value: "IpAddress", label: "IP Address" },
    { value: "MacAddress", label: "Mac Address" },
    { value: "AccountNumber", label: "Account Number" },
    { value: "Geo_Location", label: "Geo Location(Long Lat)" },
  ];

  let gridOptions = {};
  let onGridReady = {};
  const defaultColDef = {
    sortable: false,
    editable: false,
    flex: 1,
    filter: false,
  };

  const handleRuleSelect = (selectedValue) => {
    setSelectedRuleValues(selectedValue);
    let dataArrr = [];
    for (let j = 0; j < selectedValue.length; j++) {
      dataArrr.push(selectedValue[j]);
    }
    for (let i = 0; i < 4; i++) {
      if (onClickRuleData.RuleType[rulearray[i]]) {
        let flag = true;
        for (let j = 0; j < selectedValue.length; j++) {
          if (selectedValue[j].value === rulearray[i]) {
            flag = false;
          }
          // dataArrr.push(selectedValue[j]);
        }
        if (flag) {
          let checkKey = Object.keys(onClickRuleData.RuleType)
          if (checkKey[0] == "IpAddress") {
            setIPFormatV('')
          }
          delete onClickRuleData.RuleType[rulearray[i]];
        }
      }
    }
    setDefaultVal(dataArrr);
  };

  const handlePropertySelect = (selectedValue) => {
    // check propert if prefield in multiselect
    let checkPreFiledProperty = (selectedValue.length > 0 && propertyVal.length > 0) ?
      propertyVal.filter(element => {
        if (element.value == selectedValue[selectedValue.length - 1].value || element.value == selectedValue[selectedValue.length - 1].PropertyId
          || element.PropertyId == selectedValue[selectedValue.length - 1].PropertyId) {
          return element.value
        }
      }).length : null



    // Get object keys that have less than 6 channels
    const objKeys = Object.keys(PropertyDataObject).filter(key => PropertyDataObject[key].channels.length <= 5);

    const idsNotInArray = selectedValue.length > 0 ? objKeys.includes(selectedValue[selectedValue.length - 1].PropertyId) : false


    if (selectedValue.length > 0 && !idsNotInArray && (checkPreFiledProperty < 1 || checkPreFiledProperty == null)) {
      let a = (selectedValue[selectedValue.length - 1].label + " Property cannot be added because it already has 6 Channels.")
      WarningMessage(a)
      return;
    } else {
      setSelectedPropertyValues(selectedValue);
      let arrSelect = [];
      for (let i = 0; i < selectedValue.length; i++) {
        for (let j = 0; j < array2.length; j++) {
          if (selectedValue[i].value === array2[j].value && selectedValue[i].PropertyId === array2[j].PropertyId) {
            let obj = {
              value: `${array2[j].value}`,
              label: `${array2[j].label}`,
              PropertyId: `${array2[j].PropertyId}`,
            };
            arrSelect.push(obj);
          }
        }
      }
      let ChannelData = { ...onClickData };
      ChannelData.PropertyType = arrSelect;
      setOnclickData(ChannelData);
    }
  };

  const [options, setOptions] = useState({
    chart: {
      id: "apexchart-example",
    },
    xaxis: {
      categories: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ],
    },
  });

  const handleShow = (e, item1) => {
    setSave1(false)
    let itemdata = allRuledata.filter(data => {
      if (data._id == item1._id) {
        return data
      }
    })
    let item = { ...itemdata[0] }
    if (item.RuleType.IpAddress) {
      let IPValidValue = Object.entries(item.RuleType.IpAddress);
      setIPFormatDataValue(IPValidValue);
      setIPFormatV(IPValidValue[0][0]);
      setIPFormatVal(IPValidValue[0][1])
    }
    if (item.RuleType) {
      let selectedKeys = Object.keys(item.RuleType);
      let arr = [];
      for (let i = 0; i < selectedKeys.length; i++) {
        let obj = {
          value: selectedKeys[i],
          label: selectedKeys[i],
        };
        if (selectedKeys[i] !== "Deviation" && selectedKeys[i] !== "Geo_Location_Original") {
          let ChannelData = { ...onClickRuleData };
          ChannelData[selectedKeys[i]] = item.RuleType[selectedKeys[i]];
          setOnclickData(ChannelData);
          arr.push(obj);
        }
      }
      setSelectedRuleValues(arr);
      setDefaultVal(arr);
    }

    setOnclickRuleData(item);
    if (!item.RuleType) {
      let ChannelData = { ...item };
      ChannelData["RuleType"] = {};
      setOnclickRuleData(ChannelData);
    }

    setShow(true);
  };

  const handleShow1 = (e, item, event) => {
    setSave(false);
    if (item.PropertyType) {
      let selectedKeys = item.PropertyType;
      let arr = [];
      for (let i = 0; i < selectedKeys.length; i++) {
        let obj = {
          value: selectedKeys[i].value,
          label: selectedKeys[i].label,
          PropertyId: selectedKeys[i].PropertyId,
        };
        arr.push(obj);
      }
      setSelectedPropertyValues(arr);
      setPropertyVal(arr);
    }
    setOnclickData(item);
    loadProperty();
    for (let i = 0; i < alldata.length; i++) {
      if (item._id === alldata[i]._id) {
        let ChannelData = { ...item };
        if (alldata[i].videoSource[0]) {
          ChannelData.videoSource[0] = alldata[i].videoSource[0];
          ChannelData.videoSource[1] = alldata[i].videoSource[1];
        }
        setOnclickData(ChannelData);
      }
    }
    setShow1(true);
  };

  const handleClose = () => {
    setShow(false);
    setSelectedRuleValues([]);
    setDefaultVal([]);
    setIPFormatV([]);
    setIPFormatVal([]);
    loadProperty()
  };

  const handleCloseRule = () => {
    setShowRule(false);
    setchannelRuleName('');
  };

  const handleClose3 = () => {
    setShow3(false);
    setSave3(false);
  };

  const handleShow3 = (e, item) => {
    setSave3(false);
    setShow3(true);
    setOnclickProperty(item);
  };

  const handleClose2 = () => setShow2(false);
  const handleShow2 = (event, e) => {
    setShow2(true)
    setdataStats(e)
  };

  const handleShowRule = (event, e, propertyData, index, id) => {
    if (e.PropertyType && e.PropertyType.length > 0) {
      for (let i = 0; i < e.PropertyType.length; i++) {
        if (e.PropertyType[i].PropertyId == propertyData.property._id) {
          let selectedKeys = e.PropertyType[i].AllChannelRule ? e.PropertyType[i].AllChannelRule : [];
          let arr = [];
          for (let i = 0; i < selectedKeys.length; i++) {
            let obj = {
              value: selectedKeys[i].value,
              label: selectedKeys[i].label,
              id: selectedKeys[i].id,
              // data:selectedKeys[i].data,
            };
            arr.push(obj);
          }
          setRuleSecledValue(arr)
        }
      }
    }
    setRuleForProperty(propertyData.property._id);
    setchannelRuleExisting(e.ChannelRulesId ? e.ChannelRulesId : "");
    setchannelIdforRule(e._id);
    for (let i = 0; i < e.PropertyType.length; i++) {
      if (e.PropertyType[i].PropertyId) {
        if (e.PropertyType[i].PropertyId == propertyData.property._id) {
          setchannelRuleName(e.PropertyType[i].ChannelRulesName);
          setOnclickDelete(e.PropertyType[i].ChannelRulesName);
          break;
        }
      }
    }
    setShowRule(true);
  }

  const handleClose1 = () => {
    setSave1(false);
    setShow1(false);
    setPropertyVal([]);
    setSelectedPropertyValues([])
    loadAlldata();
  };


  const loadAlldata = async () => {
    loadProperty();

  };

  const sortProperty = () => {
    if (localStorage.getItem("PropertySort") === "yes") {
      let DataObject = { ...PropertyDataObject };
      DataObject = Object.entries(DataObject)
        .sort(([, a], [, b]) => a.property.Name - b.property.Name)
        .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
      setPropertyDataObject(DataObject);
    } else {
      setPropertyDataObject(dummyPropertyDataObject);
    }
  };

  const loadProperty = async () => {
    const UserId = localStorage.getItem("UserId");
    let req = {
      UserId: JSON.stringify(UserId),
    };
    let allProperty = await httpService
      .CreateUpdate("getallProperty", req)
      .catch((err) => {
        history.push("/")
        localStorage.clear()
        return;
      });
    setAllProperty(allProperty?.data);
    props.setAllProperties(allProperty?.data)

    const UserIdData = localStorage.getItem("UserId");
    let reqAllData = {
      UserId: UserIdData,
    };

    let alldataapi = await httpService
      .CreateUpdate("getalldataapi", reqAllData)
      .catch((err) => {
        return;
      });

    setAlldata(alldataapi?.data?.channelInfodata);
    props.setAllChannels(alldataapi?.data?.channelInfodata)
    setAllDataArr(alldataapi?.data?.propertyData);
    // console.log(alldataapi?.data?.channelRuledata,"alldataapi?.data?.channelRuledata")
    setAllRuledata(alldataapi?.data?.channelRuledata);
    setAllRuledataTest(alldataapi?.data?.channelRuledata);

    let dataUserPost = { userID: localStorage.getItem("UserId") };
    let LayoutArraydata = await httpService
      .CreateUpdate("getSelectedLayout", dataUserPost)
      .catch((err) => {
        return;
      });

    let DataObject = {};
    for (let i = 0; i < allProperty?.data.length; i++) {
      DataObject[`${allProperty?.data[i]._id}`] = {
        property: allProperty?.data[i],
        channels: [],
        billboards: [],
      };
    }
    let dataChannels = alldataapi?.data?.channelInfodata;
    for (let i = 0; i < dataChannels?.length; i++) {
      for (let j = 0; j < dataChannels[i]?.PropertyType.length; j++) {
        if (dataChannels[i]?.PropertyType[j].PropertyId) {
          let val = `${dataChannels[i]?.PropertyType[j].PropertyId}`;
          dataChannels[i]["RuleKey"] = dataChannels[i]?.PropertyType[j].ChannelRulesName;
          DataObject[val].channels.push(dataChannels[i]);
        }
      }
    }
    if (
      localStorage.getItem("channelSort") === undefined ||
      localStorage.getItem("channelSort") === "" ||
      localStorage.getItem("channelSort") === "channelName"
    ) {
      Object.entries(DataObject).map((elem, ind) => {
        elem[1].channels.sort((a, b) =>
          a.channelName > b.channelName
            ? 1
            : b.channelName > a.channelName
              ? -1
              : 0
        );
      });
    } else if (localStorage.getItem("channelSort") === "channelRule") {
      Object.entries(DataObject).map((elem, ind) => {
        elem[1].channels.sort((a, b) =>
          a.RuleKey > b.RuleKey
            ? 1
            : b.RuleKey > a.RuleKey
              ? -1
              : 0
        );
      });
    }
    if (localStorage.getItem("PropertySort") === "yes") {
      sortProperty();
    }

    let dataLayouts = LayoutArraydata.data.data;
    for (let i = 0; i < dataLayouts.length; i++) {
      if (dataLayouts[i].PropertyId != undefined) {
        if (DataObject[`${dataLayouts[i].PropertyId}`] && DataObject[`${dataLayouts[i].PropertyId}`]["billboards"]) {
          DataObject[`${dataLayouts[i].PropertyId}`]["billboards"].push(
            dataLayouts[i]
          );
        }
      }
    }

    setPropertyDataObject(DataObject);
    setdummyPropertyDataObject(DataObject);

    const arr2 = [];
    for (let i = 0; i < allProperty?.data?.length; i++) {
      let obj = {
        PropertyId: `${allProperty?.data[i]?._id}`,
        value: `${allProperty?.data[i]?.Name}`,
        label: `${allProperty?.data[i]?.Name}`,
      };
      if (allProperty?.data[i]) {
        {
          arr2.push(obj);
        }
      }
    }
    setArray2(arr2);
    const arr3 = [];
    for (let i = 0; i < alldataapi?.data.channelRuledata.length; i++) {
      let obj = {
        value: `${alldataapi?.data.channelRuledata[i]._id}`,
        label: `${alldataapi?.data.channelRuledata[i].ChannelRulesName}`,
        id: `${alldataapi?.data.channelRuledata[i]._id}`,
        // data: alldataapi.data.channelRuledata[i], 
      };
      if (
        alldataapi?.data.channelRuledata[i].ChannelRulesName != undefined &&
        alldataapi?.data.channelRuledata[i].ChannelRulesName != ""
      ) {
        {
          arr3.push(obj);
        }
      }
    }
    setArray3(arr3);
  };

  const sortchannels = () => {
    let dataObj = { ...PropertyDataObject };
    if (
      localStorage.getItem("channelSort") === undefined ||
      localStorage.getItem("channelSort") === "" ||
      localStorage.getItem("channelSort") === "channelName"
    ) {
      Object.entries(dataObj).map((elem, ind) => {
        elem[1].channels.sort((a, b) =>
          a.channelName > b.channelName
            ? 1
            : b.channelName > a.channelName
              ? -1
              : 0
        );
      });
    } else if (localStorage.getItem("channelSort") === "channelRule") {
      Object.entries(dataObj).map((elem, ind) => {
        elem[1].channels.sort((a, b) =>
          a.RuleKey > b.RuleKey
            ? 1
            : b.RuleKey > a.RuleKey
              ? -1
              : 0
        );
      });
    }
    setPropertyDataObject(dataObj);
  };

  const allLayout = async () => {
    let dataUserPost = { userID: localStorage.getItem("UserId") };
    let LayoutArraydata = await httpService
      .CreateUpdate("getSelectedLayout", dataUserPost)
      .catch((err) => {
        return;
      });
    const arr1 = [];
    for (let i = 0; i < LayoutArraydata.data.data.length; i++) {
      let obj = {
        // value: `${LayoutArraydata.data.data[i].name} (${window.location.origin}/customer-portal/#/view/${LayoutArraydata.data.data[i]._id})`,
        // label: `${LayoutArraydata.data.data[i].name} (${window.location.origin}/customer-portal/#/view/${LayoutArraydata.data.data[i]._id})`,
        value: `${LayoutArraydata.data.data[i].name} (${window.location.origin}/cloud-portal/#/view/${LayoutArraydata.data.data[i]._id})`,
        label: `${LayoutArraydata.data.data[i].name} (${window.location.origin}/cloud-portal/#/view/${LayoutArraydata.data.data[i]._id})`,
      };
      //console.log(obj);
      if (LayoutArraydata.data.data[i].checked) {
        {
          arr1.push(obj);
        }
      }
    }
    setArray1(arr1);
  };

  let baseImage = "";
  const getBase64 = (file) => {
    return new Promise((resolve) => {
      let fileInfo;
      let baseURL = "";
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        baseURL = reader.result;
        resolve(baseURL);
      };
    });
  };

  const showLoader = () => {
    setLoading(true);
  }
  const hideLoader = () => {
    setLoading(false);
  }

  const getFile = async (e) => {
    const file = e.target.files[0];
    if (file) {
      await getBase64(file)
        .then((result) => {
          baseImage = result;
          let data = { ...onClickData };
          data.programIcon = baseImage;
          setOnclickData(data);
        })
        .catch((err) => {
          return;
        });
    }
  };

  const saveProgram = async () => {
    if (onClickData.PropertyType.length === 0) {
      WarningMessage("Please Select Property Name")
      return;
    }
    else if (!onClickData.channelName) {
      WarningMessage("Please Enter Channel Name");
      return;
    } else if (!onClickData.channelID) {
      WarningMessage("Please Enter Channel ID");
      return;
    }
    else if (onClickData.videoSource.length === 0) {
      WarningMessage("Please Select atleast one Videosource")
      return;
    }
    // if(checkTimeOverLaping()) return
    if (onClickData.videoSource[0] == "billboard") {
      console.log(onClickData.billboard)
      if (onClickData.billboard.length === 0) {
        WarningMessage("Please  Add  Billboards  Time !");
        return;
      }
      if ((onClickData.billboard[0].billboard_name == "" && onClickData.billboard[0].billboard == "") || (onClickData.billboard[onClickData.billboard.length - 1].billboard_name == "" && onClickData.billboard[onClickData.billboard.length - 1].billboard == "")) {
        WarningMessage("Please  Choose Layout OR Input Url !");
        return;
      } else if (onClickData.billboard[0].Timezone == "") {
        WarningMessage("Please  Select  Time Zone !");
        return;
      }
    }
    if (onClickData.videoSource[0] == "billboard" && checkTimeOverLaping()) return

    let UserId = `${localStorage.getItem("UserId")}`;
    let data = {
      data: onClickData,
      UserId: UserId,
    };
    let flag = false;

    if (data.data.videoSource[0] == "billboard") {
      let validTimeForBillboardScheduling = await CommonUtils.validateBillboardScheduling(onClickData);
      if (validTimeForBillboardScheduling) { return }
    }

    let validTimeForProgram = await CommonUtils.bilboardProgramTimeValidation(onClickData);
    if (validTimeForProgram) { return }

    let data1 = data.data.channelName
      .trim()
      .split("  ")
      .filter((word) => word !== "");
    data.data.channelName = data1.join(" ");
    if (data.data.videoSource[0] === "encoder" || data.data.videoSource[0] == "url") {
      if (!validator.isURL(data.data.videoSource[1])) {
        hideLoader();
        WarningMessage("Please enter a  valid Url !")
        return;
      }
      if (data.data.videoSource[1].substring(0, 7) != "http://" && data.data.videoSource[1].substring(0, 8) != "https://") {
        hideLoader();
        WarningMessage("Please enter a valid Url with proper http or https header!")
        return;
      }
    }
    const returndata = await httpService
      .CreateUpdate("getInfoapi", data)
      .catch((err) => {
        return;
      });

    setShow1(false);
    loadAlldata();
    hideLoader();
    if (returndata.data.message === "Successful") {
      SuccessMessage("Channel Added Successfully")
      return;
    } else if (returndata.data.message) {
      WarningMessage(returndata.data.message)
      return;
    }
  };

  const DeleteChannelRow = async (e, property) => {
    showLoader();
    let propertyId = property.property._id ? property.property._id : "";

    let data = {
      id1: e._id,
      propertyId: propertyId
    };
    const res = await httpService
      .CreateUpdate("DeleteChannelRow", data)
      .catch((err) => {
        return;
      });
    loadAlldata();
    if (res.data.message === "Successful") {
      SuccessMessage("Channel Deleted Successfully")
      hideLoader();
      return;
    }
  };

  const DeleteRule = async (event, e) => {
    showLoader();
    let data = {
      id1: e._id,
    };
    const res = await httpService
      .CreateUpdate("DeleteRule", data)
      .catch((err) => {
        return;
      });

    loadAlldata();
    if (res.data.message == "Successful") {
      SuccessMessage("Channel Rule Deleted Successfully")
      hideLoader();
    }
  };

  const DeleteConfirmationDialog = async (msg, titileMsg, event, item) => {
    Swal.fire({
      title: titileMsg,
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: "No",
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes'
    }).then((result) => {
      if (result.isConfirmed) {
        if (msg === "property") {
          DeleteProperty(event, item)
        } else if (msg === "rule") {
          DeleteRule(event, item)
        } else if (msg === "Channel") {
          DeleteChannelRow(event, item);
        }
        else if (msg === "billboard") {
          Deletebillboarddata(event, item)
        }
      }
    })
  };

  const DeleteProperty = async (event, e) => {
    showLoader();
    let data = {
      id1: e._id,
    };
    const res = await httpService
      .CreateUpdate("DeleteProperty", data)
      .catch((err) => {
        return;
      });
    loadProperty();
    loadAlldata();
    if (res.data.message === "Successful") {
      SuccessMessage("Property Deleted Successfully")
      getLicensedProperty();
      hideLoader();
    }
  };


  const UpdateChannelinfo = async () => {
    if (onClickData.PropertyType.length === 0) {
      WarningMessage("Please Select Property Name")
      return;
    }
    else if (!onClickData.channelName) {
      WarningMessage("Please Enter Channel Name");
      return;
    } else if (!onClickData.channelID) {
      WarningMessage("Please Enter Channel ID");
      return;
    }
    else if (onClickData.videoSource.length === 0) {
      WarningMessage("Please Select atleast one Videosource")
      return;
    }
    if (onClickData.videoSource[0] == "billboard") {
      console.log(onClickData.billboard)
      if (onClickData.billboard.length === 0) {
        WarningMessage("Please Schedule the time !");
        return;
      }
      if ((onClickData.billboard[0].billboard_name == "" && onClickData.billboard[0].billboard == "") || (onClickData.billboard[onClickData.billboard.length - 1].billboard_name == "" && onClickData.billboard[onClickData.billboard.length - 1].billboard == "")) {
        WarningMessage("Please  Choose Layout OR Input Url !");
        return;
      } else if (onClickData.billboard[0].Timezone == "") {
        WarningMessage("Please  Select  Time Zone !");
        return;
      }
    }
    if (onClickData.videoSource[0] == "billboard" && checkTimeOverLaping()) return
    let data = {
      id1: onClickData._id,
      program: onClickData,
    };

    if (data.program.videoSource[0] == "billboard") {
      let validTimeForBillboardScheduling = await CommonUtils.validateBillboardScheduling(onClickData);
      if (validTimeForBillboardScheduling) { return }
    }

    let validTimeForProgram = await CommonUtils.bilboardProgramTimeValidation(onClickData);
    if (validTimeForProgram) { return }

    let data1 = data.program.channelName
      .trim()
      .split("  ")
      .filter((word) => word !== "");
    data.program.channelName = data1.join(" ");
    if (data.program.videoSource[0] === "encoder" || data.program.videoSource[0] === "url") {
      if (!validator.isURL(data.program.videoSource[1])) {
        hideLoader();
        WarningMessage("Please enter a  valid Url !")
        return;
      }
      if (data.program.videoSource[1].substring(0, 7) != "http://" && data.program.videoSource[1].substring(0, 8) != "https://") {
        hideLoader();
        WarningMessage("Please enter a valid Url with proper http or https header!")
        return;
      }
    }
    const res = await httpService
      .CreateUpdate("UpdateChannelRow", data)
      .catch((err) => {
        return;
      });
    showLoader();
    setShow1(false);
    loadAlldata();
    if (res.data.message === "Successful") {
      SuccessMessage("Channel  updated successfully")
      hideLoader();
    } else if (res.data.message) {
      WarningMessage(res.data.message);
      hideLoader();
    }
  };

  const SaveProperty = async () => {
    if (onClickProperty.Name === "") {
      WarningMessage("Please enter property name")
      return;
    }
    if (onClickProperty.PhoneNumber.length < 10 || onClickProperty.PhoneNumber.length > 10 && onClickProperty.PhoneNumber.length > 0) {
      WarningMessage("Please enter valid phone number")
      return;
    }
    let UserId = `${localStorage.getItem("UserId")}`;
    let data = {
      userId: UserId,
      user: onClickProperty,
    };
    let data1 = data.user.Name.trim()
      .split("  ")
      .filter((word) => word !== "");
    data.user.ChannelRulesName = data1.join(" ");

    showLoader();
    const res = await httpService.CreateUpdate("SaveProperty", data)
      .catch((err) => {
        return;
      });

    if (res.data.message === "Successful") {
      setShow3(false);
      loadProperty();
      loadAlldata();
      SuccessMessage("Property Added Successfully")
      getLicensedProperty();
      hideLoader();
    } else if (res.data.message) {
      WarningMessage(res.data.message);
      hideLoader();
    }
  };

  const Updateproperty = async () => {
    showLoader();
    let data = {
      id: onClickProperty._id,
      user: onClickProperty,
    };
    let data1 = data.user.Name.trim()
      .split("  ")
      .filter((word) => word !== "");
    data.user.Name = data1.join(" ");
    if (data.user.Name === "") {
      hideLoader();
      WarningMessage("Please enter property name")
      return;
    }
    if (data.user.PhoneNumber.length < 10 || data.user.PhoneNumber.length > 10) {
      hideLoader();
      WarningMessage("Please enter valid phone number")
      return;
    }
    showLoader();
    const res = await httpService.CreateUpdate("UpdateProperty", data)
      .catch((err) => {
        return;
      });

    loadProperty();
    loadAlldata();
    setShow3(false);
    if (res.data.message === "Successful") {
      SuccessMessage("Property updated successfully")
      hideLoader();
      return;
    } else if (res.data.message) {
      WarningMessage(res.data.message)
      hideLoader();
    }
  };

  const saveChannelRule = async () => {
    let validInput = await CommonUtils.validateRule(onClickRuleData);
    if (!validInput) { return }
    showLoader();
    let UserId = `${localStorage.getItem("UserId")}`;
    let data = {
      userId: UserId,
      user: onClickRuleData
    };
    if (selectedRuleValues.length > 2) {
      hideLoader();
      WarningMessage("Please create a rule with two factor or single factor.")
      return false;
    }

    if (onClickRuleData.RuleType && onClickRuleData.RuleType.Geo_Location && onClickRuleData.RuleType.Geo_Location.trim().split(" ").length !== 2) {
      hideLoader();
      WarningMessage("Enter Geo Location in proper format")
      return;
    } else if (onClickRuleData.RuleType && onClickRuleData.RuleType.Geo_Location && onClickRuleData.RuleType.Geo_Location.trim().split(" ").length === 2) {
      onClickRuleData.RuleType["Geo_Location_Original"] = {
        longitude_Maxm: parseFloat(onClickRuleData.RuleType.Geo_Location.split(" ")[1]) + parseFloat(onClickRuleData.RuleType.Deviation ? parseFloat(onClickRuleData.RuleType.Deviation) * 0.0166667 : 0.0333333),
        longitude_Minm: parseFloat(onClickRuleData.RuleType.Geo_Location.split(" ")[1]) - parseFloat(onClickRuleData.RuleType.Deviation ? parseFloat(onClickRuleData.RuleType.Deviation) * 0.0166667 : 0.0333333),
        latitude_Minm: parseFloat(onClickRuleData.RuleType.Geo_Location.split(" ")[0]) - parseFloat(onClickRuleData.RuleType.Deviation ? parseFloat(onClickRuleData.RuleType.Deviation) * 0.0166667 : 0.0333333),
        latitude_Maxm: parseFloat(onClickRuleData.RuleType.Geo_Location.split(" ")[0]) + parseFloat(onClickRuleData.RuleType.Deviation ? parseFloat(onClickRuleData.RuleType.Deviation) * 0.0166667 : 0.0333333),
      }
    }
    const res = await httpService
      .CreateUpdate("SaveChannelRule", data)
      .catch((err) => {
        return;
      });
    if (res.data.ack === "2") {
      hideLoader();
      ErrorMessage(res.data.message);
      return;
    } else if (res.data.ack === "3") {
      hideLoader();
      WarningMessage(res.data.message)
      return;
    } else if (res.data.message1 && res.data.message1 === "Account number matched") {
      hideLoader();
      WarningMessage("Account number matched")
    } else {
      SuccessMessage("Channel rule created successfully")
    }
    setSelectedRuleValues([]);
    setDefaultVal([]);
    loadProperty();
    loadAlldata();
    setShow(false);
    setIPFormatV([]);
    setIPFormatVal([]);
    hideLoader();
  };

  const UpdateChannelrule = async () => {
    let validInput = await CommonUtils.validateRule(onClickRuleData);
    if (!validInput) { return }
    showLoader();
    let UserId = `${localStorage.getItem("UserId")}`;
    let data = {
      userId: UserId,
      user: onClickRuleData,
    };
    let data1 = data.user.ChannelRulesName.trim()
      .split("  ")
      .filter((word) => word !== "");
    data.user.ChannelRulesName = data1.join(" ");
    if (selectedRuleValues.length > 2) {
      hideLoader();
      WarningMessage("Please create a rule with two factor or single factor.")
      return false;
    }

    if (onClickRuleData.RuleType && onClickRuleData.RuleType.Geo_Location && onClickRuleData.RuleType.Geo_Location.trim().split(" ").length != 2) {
      hideLoader();
      WarningMessage("Enter Geo Location in proper format");
      return;
    } else if (onClickRuleData.RuleType && onClickRuleData.RuleType.Geo_Location && onClickRuleData.RuleType.Geo_Location.trim().split(" ").length === 2) {
      onClickRuleData.RuleType["Geo_Location_Original"] = {
        longitude_Maxm: parseFloat(onClickRuleData.RuleType.Geo_Location.split(" ")[1]) + parseFloat(onClickRuleData.RuleType.Deviation ? parseFloat(onClickRuleData.RuleType.Deviation) * 0.0166667 : 0.0333333),
        longitude_Minm: parseFloat(onClickRuleData.RuleType.Geo_Location.split(" ")[1]) - parseFloat(onClickRuleData.RuleType.Deviation ? parseFloat(onClickRuleData.RuleType.Deviation) * 0.0166667 : 0.0333333),
        latitude_Minm: parseFloat(onClickRuleData.RuleType.Geo_Location.split(" ")[0]) - parseFloat(onClickRuleData.RuleType.Deviation ? parseFloat(onClickRuleData.RuleType.Deviation) * 0.0166667 : 0.0333333),
        latitude_Maxm: parseFloat(onClickRuleData.RuleType.Geo_Location.split(" ")[0]) + parseFloat(onClickRuleData.RuleType.Deviation ? parseFloat(onClickRuleData.RuleType.Deviation) * 0.0166667 : 0.0333333),
      }
    }
    const res = await httpService.CreateUpdate("getruleapi", data)
      .catch((err) => {
        return;
      });
    if (res.data.ack === '1') {
      hideLoader();
      SuccessMessage(res.data.message)
    } else if (res.data.ack === '2') {
      WarningMessage(res.data.message)
      hideLoader();
    } else if (res.data.ack === '3') {
      WarningMessage(res.data.message)
      hideLoader();
    } else {
      WarningMessage("Something went wrong!")
      hideLoader();
    }
    setShow(false);
    loadAlldata();
    hideLoader();
    setSelectedRuleValues([]);
    setDefaultVal([]);
    setIPFormatV([]);
    setIPFormatVal([]);
  };

  const UpdateChannelruleForChannel = async (e, ruleDelete) => {
    e.preventDefault();
    if (ruleSecledValue.length === 0) {
      ErrorMessage('Please select a Rule !')
      return;
    }
    //validation for 'deselecting a rule' or 'not selecting a rule' or 'deselecting and then selecting a rule'
    showLoader();
    let data = {
      id: channelIdforRule,
      ruleForProperty: ruleForProperty,
      ruleDelete: ruleDelete,
      channelRules: ruleSecledValue,
    };
    const res = await httpService.CreateUpdate("UpdateChannelRuleforChannel", data)
      .catch((err) => {
        return;
      });
    setchannelIdforRule("");
    setchannelRuleExisting("");
    loadProperty();
    loadAlldata();
    setShowRule(false);
    if (res.data.message === "Successful") {
      SuccessMessage("Selected rule updated successfully")
      hideLoader();
      return;
    }
  }

  const handleC = (e) => {
    let ChannelData = { ...onClickData };
    ChannelData.channel_category = e.target.value;
    setOnclickData(ChannelData);
  };

  const handleC1 = (e) => {
    let ChannelData = { ...onClickData };
    ChannelData.channel_language = e.target.value;
    setOnclickData(ChannelData);
  };

  const IPformatFun = (e) => {
    let ChannelData = { ...onClickRuleData };
    ChannelData.RuleType["IpAddress"] = {};
    { IPFormatVal ? ChannelData.RuleType["IpAddress"][e.target.value] = IPFormatVal : ChannelData.RuleType["IpAddress"][e.target.value] = ""; }      // setOnclickRuleData(ChannelData); 
    setIPFormatData(e.target.value);
    setIPFormatV(e.target.value);
    if (e.target.value === "SingleIpAddress") {
      setIpAddressPlaceHolder('255.255.255.0')
      setIpAddressNote('')
    } else if (e.target.value === "IpAddressRange") {
      setIpAddressPlaceHolder('255.255.255.0-255.255.255.255');
      setIpAddressNote("i.e please enter XXX.XXX.XXX.XXX<->XXX.XXX.XXX.XXX");
    } else if (e.target.value === "CIDR") {
      setIpAddressNote("i.e please enter XXX.XXX.XXX.XXX/XX")
    }
  }


  const setIPvalue = (e, IPFormatData) => {
    if (IPFormatData === "SingleIpAddress") {
      let data = CommonUtils.IPValidation(e.target.value)
      if (data) {
        return
      }
    } else if (IPFormatData === "IpAddressRange") {
      if (CommonUtils.IPValidationForRange(e.target.value)) {
        return
      }
    } else if (IPFormatData === "CIDR") {
      if (CommonUtils.IPValidationWithCIDR(e.target.value)) {
        return
      }
    }
    let ChannelData = { ...onClickRuleData };
    ChannelData.RuleType["IpAddress"] = {};
    ChannelData.RuleType["IpAddress"][IPFormatData] = e.target.value;
    setOnclickRuleData(ChannelData);
    setIPFormatVal(e.target.value)
  }

  const handlec2 = (e) => {

    if (e.target.name === "MacAddress") {
      if (CommonUtils.MacValidation(e.target.value)) return;
      let ChannelData = { ...onClickRuleData };
      ChannelData.RuleType["MacAddress"] = e.target.value.toUpperCase();
      setOnclickRuleData(ChannelData);
    }
    if (e.target.name === "AccountNumber") {
      let ChannelData = { ...onClickRuleData };
      ChannelData.RuleType["AccountNumber"] = e.target.value;
      setOnclickRuleData(ChannelData);
    }
    if (e.target.name === "Geo_Location") {
      let ChannelData = { ...onClickRuleData };
      if (e.target.value.match(/[^0-9. -]/) || e.target.value.split(' ').length > 2 ||
        e.target.value.split(' ')[0].length != 1 && isNaN(e.target.value.split(' ')[0]) ||
        (e.target.value.split(' ').length === 2 && (e.target.value.split(' ')[0].length != 1 &&
          isNaN(e.target.value.split(' ')[0]) || e.target.value.split(' ')[1].length != 1 && isNaN(e.target.value.split(' ')[1])))
      ) {
        return
      }
      ChannelData.RuleType["Geo_Location"] = e.target.value;
      setOnclickRuleData(ChannelData);
    }
    if (e.target.name === "Deviation") {
      let ChannelData = { ...onClickRuleData };
      ChannelData.RuleType["Deviation"] = e.target.value;
      setOnclickRuleData(ChannelData);
    }
  };

  const ischecked = (event) => {
    if (event.target.value === "billboard") {
      let ChannelData = { ...onClickData };
      ChannelData.videoSource[0] = event.target.value;
      ChannelData.videoSource[1] = "";
      setOnclickData(ChannelData);
      if (ChannelData.billboard.length == 0) {
        addbillboard();
      }
    }
    if (event.target.value === "url") {
      let ChannelData = { ...onClickData };
      ChannelData.videoSource[0] = event.target.value;
      ChannelData.videoSource[1] = "";
      setOnclickData(ChannelData);
      DeleteAllBillboards()
    }
    if (event.target.value === "encoder") {
      let ChannelData = { ...onClickData };
      ChannelData.videoSource[0] = event.target.value;
      ChannelData.videoSource[1] = "";
      setOnclickData(ChannelData);
      DeleteAllBillboards()
    }
  };

  const onInputChange = (e) => {
    setSelectedValue(e.target.value);
    setOnclickData({ ...onClickData, [e.target.name]: e.target.value });
  };

  const onInputRuleChange = (e) => {
    setSelectedValue(e.target.value);
    setOnclickRuleData({ ...onClickRuleData, [e.target.name]: e.target.value });
  };

  const addprogram = async () => {
    let ChannelData = { ...onClickData };
    ChannelData.program.push({
      title: "",
      language: "",
      duration: 0,
      startTime: "00:00",
      endTime: "00:00",
      description: "",
    });
    setOnclickData(ChannelData);
  };

  const addbillboard = async () => {
    let ChannelData = { ...onClickData };
    ChannelData.billboard.push({
      billboard: "",
      billboard_name: "",
      startTime: "00:00",
      endTime: "00:00",
      Timezone: "",
    });
    setOnclickData(ChannelData);
  };

  let checkTimeOverLaping = () => {
    return TimeOverLaping(onClickData.billboard);
  };

  const Deletebillboarddata = async (event, i) => {
    let ChannelData = { ...onClickData };
    ChannelData.billboard.splice(i, 1);
    setOnclickData(ChannelData);
  };
  const DeleteAllBillboards = async () => {
    let ChannelData = { ...onClickData };
    ChannelData.billboard = [];
    setOnclickData(ChannelData);
  };

  const handlebillboardstarttime = (elem, i) => {
    if (elem) {
      let ChannelData = { ...onClickData };
      ChannelData.billboard[i].startTime = elem.substring(0, 5);
      setOnclickData(ChannelData);
      // if(ChannelData.billboard[i].startTime > 12){
      //   elem.toLocaleString('en-US', { hour: 'numeric', hour12: true , minute: 'numeric' })
      // }

      if (ChannelData.billboard[i].endTime) {
        let startTime = elem;
        let startHour =
          parseInt(startTime.split(":")[0]) +
          parseInt(startTime.split(":")[1]) / 60;
        let endTime = ChannelData.billboard[i].endTime;
        let endHour =
          parseInt(endTime.split(":")[0]) +
          parseInt(endTime.split(":")[1]) / 60;
        if (endHour >= startHour) {
          let duration = Math.round((endHour - startHour) * 60);
          ChannelData.billboard[i].duration = duration;
        } else {
          let duration = Math.round((endHour - startHour + 24) * 60);
          ChannelData.billboard[i].duration = duration;
        }
      }
    }
  }



  const handlebillboardendtime = (elem, i) => {
    if (elem) {
      let ChannelData = { ...onClickData };
      ChannelData.billboard[i].endTime = elem.substring(0, 5);
      setOnclickData(ChannelData);
      // if(ChannelData.billboard[i].endTime > 12){
      //   elem.toLocaleString('en-US', { hour: 'numeric', hour12: true })
      // }
      if (ChannelData.billboard[i].startTime) {
        let endTime = elem;
        let startTime = ChannelData.billboard[i].startTime;

        let startHour =
          parseInt(startTime.split(":")[0]) +
          parseInt(startTime.split(":")[1]) / 60;
        let endHour =
          parseInt(endTime.split(":")[0]) +
          parseInt(endTime.split(":")[1]) / 60;
        if (endHour >= startHour) {
          let duration = Math.round((endHour - startHour) * 60);
          ChannelData.billboard[i].duration = duration;
        } else {
          let duration = Math.round((endHour - startHour + 24) * 60);
          ChannelData.billboard[i].duration = duration;
        }
      }
    }
  }

  const timeZone = [
    {
      label: "Select Timezone",
      value: "",
    },
    {
      label: "Eastern Time",
      value: "EST",
    },
    {
      label: "Central Time",
      value: "CST",
    },
    {
      label: "Mountain Time",
      value: "MST",
    },
    {
      label: "Pacific Time",
      value: "PST",
    }, {
      label: "Alaska Time",
      value: "AKST",
    }, {
      label: "Hawaii Time",
      value: "HST",
    },
  ];

  const handleStartTime = (e, i) => {
    if (e) {
      let ChannelData = { ...onClickData };
      ChannelData.program[i].startTime = e.substring(0, 5);
      setOnclickData(ChannelData);
      if (ChannelData.program[i].endTime) {
        let startTime = e;
        let startHour =
          parseInt(startTime.split(":")[0]) +
          parseInt(startTime.split(":")[1]) / 60;
        let endTime = ChannelData.program[i].endTime;
        let endHour =
          parseInt(endTime.split(":")[0]) +
          parseInt(endTime.split(":")[1]) / 60;
        if (endHour >= startHour) {
          let duration = Math.round((endHour - startHour) * 60);
          ChannelData.program[i].duration = duration;
        } else {
          let duration = Math.round((endHour - startHour + 24) * 60);
          ChannelData.program[i].duration = duration;
        }
      }
    }
  };

  const handleEndTime = (e, i) => {
    if (e) {
      let ChannelData = { ...onClickData };
      ChannelData.program[i].endTime = e.substring(0, 5);
      setOnclickData(ChannelData);
      if (ChannelData.program[i].startTime) {
        let endTime = e;
        let startTime = ChannelData.program[i].startTime;

        let startHour =
          parseInt(startTime.split(":")[0]) +
          parseInt(startTime.split(":")[1]) / 60;
        let endHour =
          parseInt(endTime.split(":")[0]) +
          parseInt(endTime.split(":")[1]) / 60;
        if (endHour >= startHour) {
          let duration = Math.round((endHour - startHour) * 60);
          ChannelData.program[i].duration = duration;
        } else {
          let duration = Math.round((endHour - startHour + 24) * 60);
          ChannelData.program[i].duration = duration;
        }
      }
    }
  };

  const handleChangeProgram = (e, i, name) => {
    let ChannelData = { ...onClickData };
    ChannelData.program[i][`${name}`] = e;
    setOnclickData(ChannelData);
  };

  const handleChangeBillboard = (e, i, name, billboard_name) => {
    let linknamechange = e.value;
    //let flag1 = e.innerText;
    let label = linknamechange.split(" (")[0].trim();
    let linkValue1 = linknamechange.split(" (")[1].trim();
    let linkValue = linkValue1.split(")")[0];
    let ChannelData = { ...onClickData };
    ChannelData.billboard[i][`${name}`] = linkValue;
    ChannelData.billboard[i][`${billboard_name}`] = label;
    console.log('channeldata', ChannelData);
    setOnclickData(ChannelData);
  };

  const handletimezoneChange = (e, i, name) => {
    // console.log(e,"time zone seletct")
    // let ChannelData = { ...onClickData };
    // ChannelData.billboard[i][`${name}`] = e;
    // setOnclickData(ChannelData);
    let ChannelData = { ...onClickData };
    if (name === 'Timezone')
      ChannelData.billboard.forEach(ele => ele[`${name}`] = e);
    else
      ChannelData.billboard[i][`${name}`] = e;
    setOnclickData(ChannelData);

  }
  useEffect(async () => {
    showLoader();
    let dataUserPost = { userID: localStorage.getItem("UserId") };
    let LayoutArraydata = await httpService
      .CreateUpdate("getSelectedLayout", dataUserPost)
      .catch((err) => {
        if (err && err.response && err.response.status == 401 && localStorage.getItem("UserId")) {
          ErrorMessage("Session expired, please login again")
        }
        return;
      });
    let propertyToggleData = localStorage.getItem("propertyToggleData") ? JSON.parse(localStorage.getItem("propertyToggleData")) : {};
    setpropertyToggle(propertyToggleData);
    props.setpropertyToggles(propertyToggleData)
    setlayoutArray(LayoutArraydata.data.data);
    hideLoader();
  }, []);
  const handlelayoutTypechange = (e, i, name, type) => {
    let ChannelData = { ...onClickData };
    ChannelData.billboard[i][`${name}`] = type;
    setOnclickData(ChannelData);
  }

  const onInputChange1 = (e) => {
    setOnclickData({ ...onClickData, [e.target.name]: e.target.value });
  };

  const onInputChange3 = (e) => {
    setOnclickProperty({ ...onClickProperty, [e.target.name]: e.target.value });
  };

  const addClickHandler = (e) => {
    setOnclickData({
      channelName: "",
      channelDescription: "",
      channel_category: "",
      channel_language: "",
      programIcon: "",
      videoSource: [],
      program: [],
      PropertyType: [],
      billboard: [],
    });
    setShow1(true);
    setSave(true);
  };

  let dlvalue = true;
  const addClickHandler2 = (e) => {
    setDefaultVal([]);
    setOnclickRuleData({
      ChannelRulesName: "",
      RuleType: {}
    });
    setShow(true);
    setSave1(true);

  };

  const addClickHandler1 = (e) => {
    setOnclickProperty({
      Name: "",
      Address1: "",
      Address2: "",
      Country: "",
      State: "",
      City: "",
      Zip: "",
      PhoneNumber: "",
      Email: "",
      ContactName: "",
    });
    setShow3(true);
    setSave3(true);
  };

  const handleselectedR = (selectedValue) => {
    let dataArrr = [];
    for (let j = 0; j < selectedValue.length; j++) {
      dataArrr.push(selectedValue[j]);
    };
    setRuleSecledValue(dataArrr);
  }

  const getWarningMessage = async () => {
    let userID = localStorage.getItem("UserId");
    let data = {
      userID: userID
    }
    try {
      let res = await httpService.getByBoj('getwarningmsg', data)
      if (res.data.data && res.data.data.length > 0) {
        setWarningMsg(res.data.data)
      } else {
        setWarningMsgToggle(false)
      }
    }
    catch (err) {
      return
    }
  }

  const clearWarningData = async () => {
    let userID = localStorage.getItem("UserId");
    let data = {
      userID: userID
    }

    try {
      let res = await httpService.getByBoj('clearwarningmsg', data)
      if (res.data.ack == "1") {
        setWarningMsgToggle(false)
      }
      setWarningMsgToggle(false)
    }
    catch (err) {
      return
    }
  }

  const inputValidation = (e) => {
    if (e.target.selectionStart === 0 && e.key === " ") {
      e.preventDefault();
    }
    if (e.key.match(/[0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/)) {
      e.preventDefault();
    }
  }

  useEffect(() => {
    console.log("location : ", location.pathname)
    showLoader();
    // loadAlldata();
    loadProperty();
    allLayout();
    getLicensedProperty();
    hideLoader();
    getWarningMessage();
  }, [location.pathname]);

  useEffect(async () => {
    showLoader();
    let dataUserPost = { userID: localStorage.getItem("UserId") };
    let LayoutArraydata = await httpService
      .CreateUpdate("getSelectedLayout", dataUserPost)
      .catch((err) => {
        if (err && err.response && err.response.status == 401 && localStorage.getItem("UserId")) {
          ErrorMessage("Session expired, please login again")
        }
        return;
      });
    let propertyToggleData = localStorage.getItem("propertyToggleData") ? JSON.parse(localStorage.getItem("propertyToggleData")) : {};
    setpropertyToggle(propertyToggleData);
    props.setpropertyToggles(propertyToggleData)
    setlayoutArray(LayoutArraydata.data.data);
    hideLoader();
  }, []);

  console.log(alldata, "all Data")
  return (
    <div classname="mainClass">
      {loading ? <Loader /> : null}
      {warningMsgToggle && <div className="warning-message-Dashboard">
        {"These account number already in use "}
        {warningMsg && warningMsg.map((item, k) => {
          return (
            <>
              {warningMsg.length - 1 == k ? <span>{item}</span> : <span>{item}{", "}</span>}

            </>
          )
        })}
        <span className="fa fa-close authentication-close-btn " onClick={() => clearWarningData()}></span>

      </div>}

      {/* <div className="form-boxdiv form-box-margin">
        <div className="form-boxtopline5 mb-2 row">
          <div className="col-9">Billboards</div>
          <div className="col-3 editBillboard">
            <Button
              color="primary"
              className="form-control"
              onClick={() => {
                history.push("/content");
              }}
            >
              Edit Billboard
            </Button>
          </div>
        </div>

        <div className="custom-control custom-checkbox bilboard-custom-control">
          <div className="bilboard-FormScroll">
            <div className="row">
              {allProperty.map((e, i) => {
                return (
                  <div
                    className="col-3 billBoard-thumbnail"
                    style={{ paddingLeft: "10px" }}
                  >
                    <div
                      className="billboardImage"
                      style={{
                        border: "1px solid gray",
                        borderRadius: "3px",
                        paddingRight: "10px",
                      }}
                    >
                      <div
                        className="text-center layoutName row"
                        style={{ marginTop: "5px" }}
                      >
                        <b className="col-9">{e.Name}</b>
                        <div
                          className="col-3"
                          style={{ color: "white" }}
                          onClick={() => {
                            history.push(`/content/${e._id}`);
                          }}>

                          <Button color="secondary" className="form-control" >
                            View
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

          </div>
        </div>
      </div> */}





      <div className="form-boxdiv">
        <div className="form-boxtopline5 row">
          <div className="col">
            PROPERTIES
          </div>
          {userRole === "property_user" ? <div className="col text-center"></div> : <div className="col text-center">
            Licenses Used/Available:- <span style={{ border: "2px solid black", padding: "3px", color: "#002c42ce" }}>{`${usedPropertyLicences.UsedProperty}/${usedPropertyLicences.licenceNo}`}</span>
            {/* <input
              // style="width: 300px;"
              style={{ width: "50px", textAlign: "center" }}
              type="text"
              size={5}
              value={`${usedPropertyLicences.UsedProperty}/${usedPropertyLicences.licenceNo}`}
            /> */}

          </div>}

          <div className="text-end col">

            {userRole === "property_user" ? < div ></div> : <button

              title="Create New Property"
              className="btn btn-sm btn-primary"
              hidden={hideProperty}
              onClick={(e) => {
                setOnClickAddAndEditMsg("Add Property");
                addClickHandler1(e)
              }
              }
            >
              Add Property
            </button>}

            {/* <button
              className="btn btn-sm btn-primary ms-2"
              onClick={(e) => {
                setOnClickAddAndEditMsg("Add Channel")
                setSelectedPropertyValues([])
                addClickHandler(e)
              }}
            >
              Add Channel
            </button> */}
            <button
              className="btn btn-sm btn-primary ms-2"
              // hidden={hideRule}
              // onClick={(e) => {
              //   setOnClickAddAndEditMsg("Create Rule")
              //   addClickHandler2(e)
              //   setIpAddressNote('')
              // }}
              onClick={() => { history.push(`/rulesdashboard`) }}
            // id={"rule" }
            >
              Channel Access Permission
            </button>
          </div>
        </div>

        <div className="p-3">
          {userRole !== "property_user" && <p style={{
            backgroundColor: usedPropertyLicences.backgroundColor,
            padding: '2px',
            textAlign: 'center',
            borderRadius: `20px`,
            border: "1px solid #e2e2e2"
          }}>Expiry Date :- {usedPropertyLicences.endDate} </p>}


          <div>
            <div className="property-table-scroll">
              <Table hover className="channelsTable border m-0 table-striped ">
                <thead className="fix-tableHead">
                  <tr>
                    <th
                      className="dasboardTH"
                      onClick={() => {
                        if (localStorage.getItem("PropertySort") === "yes") {
                          localStorage.setItem("PropertySort", "no");
                          sortProperty();
                        } else {
                          localStorage.setItem("PropertySort", "yes");
                          sortProperty();
                        }
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      Property{" "}

                    </th>
                    <th className="dasboardTH">No Of Channels</th>
                    <th className="dasboardTH">Layouts</th>
                    { }
                    {userRole !== "property_user" && <th className="dasboardTH text-end">Edit {" |  "} Delete</th>}
                  </tr>
                </thead>
                <tbody>
                  {(localStorage.getItem("PropertySort") === "yes" ? Object.entries(PropertyDataObject).slice().sort(function (a, b) { return a[1].property.Name < b[1].property.Name ? -1 : a[1].property.Name > b[1].property.Name ? 1 : 0 })
                    : Object.entries(PropertyDataObject)).map((item, index) => {
                      return (
                        <>
                          <tr style={{ borderTop: "1px solid gray" }}>
                            {/* new design -- */}
                            <td title="Go To Channels">
                              <span onClick={() => {
                                history.push({ pathname: `/propertychannle/${item[1].property._id}`, state: { key1: item[1].property.Name } });
                                // activeClass
                                //   ? setActiveClass("")
                                //   : setActiveClass(index);
                                // let propertyToggleData = localStorage.getItem("propertyToggleData") ? JSON.parse(localStorage.getItem("propertyToggleData")) : {};
                                // if (propertyToggleData[`${item[1].property._id}`] && propertyToggleData[`${item[1].property._id}`] === true) {
                                //   propertyToggleData[`${item[1].property._id}`] = false
                                // }
                                // else {
                                //   propertyToggleData[`${item[1].property._id}`] = true
                                // };
                                // localStorage.setItem("propertyToggleData", JSON.stringify(propertyToggleData));
                                // setpropertyToggle(propertyToggleData);
                                // props.setpropertyToggles(propertyToggleData)

                              }
                              }
                                id={"toggler" + index} style={{ wordBreak: "break-all" }}> {item[1].property.Name} </span>
                              {/* <button
                                className="btn btn-sm btn-secondary"
                                style={{ marginLeft: "10px" }}
                                onClick={(event) => {
                                  setOnClickAddAndEditMsg("Edit Property")
                                  handleShow3(event, item[1].property)
                                }}
                              >
                                <i className="edit icon me-0"></i>
                              </button> */}
                            </td>
                            <td title="Go To Channels"><span className="text-primary" onClick={() => { history.push({ pathname: `/propertychannle/${item[1].property._id}`, state: { key1: item[1].property.Name } }) }} id={"channle" + index}> {item[1].channels.length}</span></td>
                            <td><span className="text-primary" title="Click To Open Layout" onClick={() => { history.push(`/content/${item[1].property._id}`) }} id={"layout" + index}> {/**item[1].property.Name**/}View Layouts </span></td>


                            {userRole !== "property_user" && <td className="text-end">
                              <button
                                title="Edit Property"
                                className="btn btn-sm btn-secondary"

                                onClick={(event) => {
                                  setOnClickAddAndEditMsg("Edit Property")
                                  handleShow3(event, item[1].property)
                                }}
                              >
                                <i title="Edit Property" className="edit icon me-0" ></i>
                              </button>{" "}
                              <button
                                title="Delete Property"
                                style={{ marginLeft: "20px" }}
                                className="btn btn-sm btn-danger"
                                onClick={(event) => {
                                  DeleteConfirmationDialog("property", "Are you sure want to delete this  property?", event, item[1].property);
                                }}
                              >
                                <i className="trash icon me-0"></i>
                              </button>{"  "}
                            </td>}

                            {/* -------// */}
                          </tr>

                          {/* <div
                            hidden={!(props.propertyToggles[`${item[1].property._id}`] != undefined && props.propertyToggles[`${item[1].property._id}`])
                            }
                            width="100%"
                          >
                            <div
                              style={{
                                borderBottom: "1px solid rgb(186 186 186 / 48%)",
                                paddingBottom: "10px",
                              }}
                              width="100%"
                            >
                              <Table
                                striped
                                bordered
                                hover
                                size=""
                                style={{
                                  marginLeft: "7%",
                                  marginTop: "10px",
                                  marginBottom: "10px",
                                }}
                                className="mb-0"
                              >
                                <thead>
                                  <tr>
                                    <th
                                      onClick={() => {
                                        localStorage.setItem(
                                          "channelSort",
                                          "channelName"
                                        );
                                        sortchannels();
                                      }}
                                      style={{ cursor: "pointer" }}
                                      className="dasboardTH"
                                    >
                                      <div
                                        style={
                                          localStorage.getItem("channelSort") ===
                                            undefined ||
                                            localStorage.getItem("channelSort") === "" ||
                                            localStorage.getItem("channelSort") ===
                                            "channelName"
                                            ? {
                                              borderBottom: "3px solid white",
                                              paddingBottom: "8px",
                                            }
                                            : {
                                              borderBottom: "0px solid white",
                                              paddingBottom: "8px",
                                            }
                                        }
                                      >
                                        <div>Channels</div>
                                      </div>
                                    </th>
                                    <th
                                      className="dasboardTH"
                                      onClick={() => {
                                        localStorage.setItem(
                                          "channelSort",
                                          "channelRule"
                                        );
                                        sortchannels();
                                      }}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <div
                                        style={
                                          localStorage.getItem("channelSort") ===
                                            "channelRule"
                                            ? {
                                              borderBottom: "3px solid white",
                                              paddingBottom: "8px",
                                            }
                                            : {
                                              borderBottom: "0px solid white",
                                              paddingBottom: "8px",
                                            }
                                        }
                                      >
                                        <div>Channel Rules</div>
                                      </div>
                                    </th>
                                    <th className="dasboardTH">Channel Statistics</th>
                                    <th className="dasboardTH">
                                      Webcaster Management
                                    </th>
                                    <th className="dasboardTH">Delete</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {item[1].channels
                                    .slice(0)
                                    .reverse()
                                    .map((e, id) => {
                                      return (
                                        <tr>
                                          <td
                                            onClick={(event) => {
                                              setOnClickAddAndEditMsg("Edit Channel")
                                              handleShow1(event, e, item[1].channels)
                                            }}
                                          >
                                            {e.channelName === undefined ||
                                              e.channelName === ""
                                              ? "Add Channel"
                                              : e.channelName}{" "}
                                          </td>
                                          <td>
                                            {
                                              e.PropertyType.find(obj => item[1].property._id === obj.PropertyId).AllChannelRule &&
                                                e.PropertyType.find(obj => item[1].property._id === obj.PropertyId).AllChannelRule.length > 0
                                                ? <span className="text-primary" onClick={(event) => handleShowRule(event, e, item[1], index, id)}>View Rule</span> :
                                                <span className="text-primary" onClick={(event) => handleShowRule(event, e, item[1], index, id)}>Select Rule</span>
                                            }
                                          </td>
                                          <td
                                            onClick={(event) => handleShow2(event, e)}
                                          >
                                            channel Statistics
                                          </td>

                                          {(e.videoSource ? (e.videoSource[0] ? (e.videoSource[0] === "url" || e.videoSource[0] === "billboard") : true) : true) === true ? <td></td> : <td onClick={() => window.open(e.videoSource[1], "_blank")}> Webcaster Management</td>}
                                          <td>
                                            <button
                                              className="btn btn-sm btn-outline-danger"
                                              onClick={(event) => {
                                                DeleteConfirmationDialog('Channel', 'Are you sure want to delete this channel?', e, item[1])

                                              }}
                                            >
                                              <i className="trash icon me-0"></i>
                                            </button>{" "}
                                          </td>
                                        </tr>
                                      );
                                    })}
                                </tbody>
                              </Table>

                            </div>
                          </div> */}
                        </>
                      );
                    })}

                  {/* </>
                  ); 
                })} */}
                </tbody>
              </Table></div></div>
        </div>
      </div>
      {/* new design --- */}
      {/* {newFunction(columns, defaultColDef, allRuledata, gridOptions, onGridReady)} */}
      <Modal show={show3} onHide={handleClose3}>
        <Modal.Header closeButton>
          <Modal.Title>
            {onClickAddAndEditMsg}
          </Modal.Title>
        </Modal.Header>
        <div className="ui main">
          <form className="ui form">
            <div className="field position-relative ">
              <label >Name<i style={{ color: "red" }} >*</i></label>
              <input
                required
                type="text"
                name="Name"
                placeholder="Name"
                maxLength={100}
                onKeyDown={(e) => {
                  if (e.target.selectionStart === 0 && e.key === " ") {
                    e.preventDefault();
                  }
                }}
                onChange={(e) => {
                  onInputChange3(e)
                }}
                value={onClickProperty.Name}
              />
            </div>
            <div className="field">
              <label>Address1</label>
              <input
                type="text"
                name="Address1"
                placeholder="Address1"
                onKeyDown={(e) => {
                  if (e.target.selectionStart === 0 && e.key === " ") {
                    e.preventDefault();
                  }
                }}
                onChange={(e) => onInputChange3(e)}
                value={onClickProperty.Address1}
              />
            </div>
            <div className="field">
              <label>Address2</label>
              <input
                type="text"
                name="Address2"
                placeholder="Address2"
                onKeyDown={(e) => {
                  if (e.target.selectionStart === 0 && e.key === " ") {
                    e.preventDefault();
                  }
                }}
                onChange={(e) => onInputChange3(e)}
                value={onClickProperty.Address2}
              />
            </div>
            <div className="row">
              <div className="field col-6" style={{ paddingRight: "3px" }}>
                <label>Country</label>
                <input
                  type="text"
                  name="Country"
                  placeholder="Country"
                  onKeyDown={(e) => {
                    inputValidation(e);
                  }}
                  onChange={(e) => onInputChange3(e)}
                  value={onClickProperty.Country}
                />
              </div>
              <div className="field col-6" style={{ paddingLeft: "3px" }}>
                <label>State</label>
                <input
                  type="text"
                  name="State"
                  placeholder="State"
                  onKeyDown={(e) => {
                    inputValidation(e);
                  }}
                  onChange={(e) => onInputChange3(e)}
                  value={onClickProperty.State}
                />
              </div>
              <div className="field col-6" style={{ paddingRight: "3px" }}>
                <label>City</label>
                <input
                  type="text"
                  name="City"
                  placeholder="City"
                  onKeyDown={(e) => {
                    inputValidation(e);
                  }}
                  onChange={(e) => onInputChange3(e)}
                  value={onClickProperty.City}
                />
              </div>
              <div className="field col-6" style={{ paddingLeft: "3px" }}>
                <label>Zip</label>
                <input
                  type="text"
                  name="Zip"
                  placeholder="Zip"
                  onChange={(e) => {
                    const { value } = e.target;
                    const regex = /^\d*$/

                    if (regex.test(value)) {
                      onInputChange3(e)
                    }
                  }}
                  value={onClickProperty.Zip}
                />
              </div>
            </div>

            <div className="field">
              <label>Phone Number<i style={{ color: "red" }}>*</i> </label>
              <input
                type="text"
                name="PhoneNumber"
                placeholder="Phone"
                maxlength="10"
                pattern="[1-9]{1}[0-9]{9}"
                onChange={(e) => {
                  if (
                    e.target.value.match(/[^0-9]/) === null &&
                    e.target.value.length <= 10
                  ) {
                    onInputChange3(e)
                  }
                }}
                value={onClickProperty.PhoneNumber}
              />
            </div>
            <div className="field">
              <label>Email</label>
              <input
                type="text"
                name="Email"
                placeholder="Email"
                onChange={(e) => onInputChange3(e)}
                value={onClickProperty.Email}
              />
            </div>
            <div className="field">
              <label>Contact Name</label>
              <input
                type="text"
                name="ContactName"
                placeholder="Contact Name"
                onKeyDown={(e) => {
                  inputValidation(e);
                }}
                onChange={(e) => onInputChange3(e)}
                value={onClickProperty.ContactName}
              />
            </div>
          </form>
        </div>
        <Modal.Footer>
          <Button
            color="success"
            onClick={() => {
              // UpdateChannelrule();
              if (save3) {
                SaveProperty();
              } else {
                Updateproperty();
              }
            }}
          >
            {save3 ? "Save" : "Update"}
          </Button>
          <Button
            color="danger"
            onClick={() => {
              setShow3(false);
              setSave3(false);
            }}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton className="model-header-text">
          <Modal.Title>
            {onClickAddAndEditMsg}
            <div class="row">
              <div className="col-12 model-note1">  Note: Only applicable two factor combinations are:</div>
            </div>

            <div class="row">
              <div class="col-4 model-note1"><span className="model-note-icon1">1</span>. Account+GEO</div>
              <div class="col-4 model-note1 text-center"><span className="model-note-icon1">2</span>. IP+GEO </div>
              <div class="col-4 model-note1"><span className="model-note-icon1">3</span>. MAC+GEO</div>
            </div>

          </Modal.Title>

        </Modal.Header>
        <div className="ui main">
          <form className="ui form">


            <div className="field">
              <label>Channel Rules Name<i style={{ color: "red" }}>*</i></label>
              <input
                type="text"
                name="ChannelRulesName"
                placeholder="Channel Rules Name "
                onChange={(e) => onInputRuleChange(e)}
                value={onClickRuleData.ChannelRulesName}
              />
            </div>
            <div className="field" style={{ padding: "10px", border: "1px solid #53535369" }}>
              <label>Rule Type<i style={{ color: "red" }}>*</i></label>
              <Select
                isMulti
                name="colors"
                options={ruleSelectValues}
                value={defaultVal}
                onChange={handleRuleSelect}
                className="basic-multi-select"
                classNamePrefix="select"
              />
              {onClickRuleData.RuleType && selectedRuleValues.length > 0
                ? selectedRuleValues.map((elm, index) => {
                  return (
                    <>
                      {" "}
                      {elm.value != "Deviation" && elm.value != "Geo_Location_Original" ? <div>
                        <label style={{ marginRight: "3px", fontWeight: "bold" }}>
                          {elm.value === "Geo_Location" ? "Geo Location" : elm.label}
                        </label>
                        {elm.value === "Geo_Location" && <span className="text-secondary ml-2">{elm.value == "Geo_Location" && "i.e please enter <Lat><space><Long>"}</span>}
                        {elm.value === "IpAddress" && <span className="text-secondary ml-2"> {ipAddressNote}</span>}
                        {elm.value === "IpAddress" ?
                          <div className="row">
                            <div className="col-4">
                              <select className="form-control" name="IpFormat"
                                onChange={(event) => IPformatFun(event)}
                                value={IPFormatV ? IPFormatV : ""}>
                                <option hidden >Select IP Format</option>
                                <option value="SingleIpAddress">Single IP address</option>
                                <option value="IpAddressRange"> IP address range</option>
                                <option value="CIDR">CIDR </option>
                              </select>
                            </div>
                            {onClickRuleData.RuleType && onClickRuleData.RuleType.IpAddress ?
                              <div className="col-8">
                                <input
                                  type="text"
                                  className=""
                                  style={{ marginLeft: "5px", paddingRight: "5px" }}
                                  onChange={(event) => {
                                    setIPvalue(event, IPFormatV);
                                  }}
                                  placeholder={ipAddressPlaceHolder}
                                  value={IPFormatVal ? IPFormatVal : ""}
                                ></input> </div> : ""
                            }
                          </div>
                          : <input
                            type="text"
                            style={{ marginTop: "3px" }}
                            name={elm.value}
                            value={
                              onClickRuleData.RuleType[elm.value]
                                ? onClickRuleData.RuleType[elm.value]
                                : ''
                            }
                            placeholder={elm.label}
                            onChange={(event) => {
                              handlec2(event)
                            }}
                          ></input>}
                      </div> : ""
                      }

                      {elm.value === "Geo_Location" ? <div>
                        <label
                          style={{ marginRight: "3px", fontWeight: "bold" }}
                        >
                          Deviation (in mins)
                        </label>
                        <input
                          type="text"
                          style={{ marginTop: "3px", marginBottom: "5px" }}
                          name="Deviation"
                          value={
                            onClickRuleData.RuleType
                              ? onClickRuleData.RuleType["Deviation"] ? onClickRuleData.RuleType["Deviation"] : ""
                              : ""
                          }
                          placeholder={"Deviation"}
                          onChange={(event) => {
                            handlec2(event);
                          }}
                        ></input>
                      </div> : ""
                      }
                    </>
                  );
                })
                : ""}
            </div>
          </form>
        </div>
        <Modal.Footer>
          <Button
            color="success"
            onClick={() => {
              if (save1) {
                saveChannelRule();
              }
              else { UpdateChannelrule(); }
            }}
          >
            {save1 ? "Save" : "Update"}
          </Button>
          <Button
            color="danger"
            onClick={() => {
              setShow(false);
              setOnclickRuleData({})
              setSelectedRuleValues([]);
              loadProperty()
              setDefaultVal([]);
              setIPFormatV([]);
              setIPFormatVal([]);
            }}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showRule} onHide={handleCloseRule}>
        <Modal.Header closeButton>
          <Modal.Title>
            {onClickDelete ? "Edit Rule" : "Select Rule"}
          </Modal.Title>
        </Modal.Header>
        <div className="ui main">
          <form className="ui form">
            <div className="field">
              <label>Select Channel Rule</label>
              <Select
                isMulti
                name="Rule Name"
                options={array3}
                placeholder="Choose Rule..."
                defaultValue={ruleSecledValue}
                onChange={(event) => { handleselectedR(event) }}
                className="basic-multi-select"
                classNamePrefix="select"
              />
            </div>

          </form>
        </div>
        <Modal.Footer>
          <Button color="success" onClick={(e) => {
            UpdateChannelruleForChannel(e);
            setchannelRuleName('');
          }}>
            {onClickDelete ? "Update" : "Save"}
          </Button>
          <Button
            color="danger"
            onClick={() => {
              setShowRule(false);
              setchannelRuleName('');
            }}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal size="lg" show={show1} onHide={handleClose1}>
        <Modal.Header closeButton>
          <Modal.Title>
            {onClickAddAndEditMsg}
          </Modal.Title>
        </Modal.Header>
        <div className="ui main">
          <form className="ui form row">
            <div className="field position-relative">
              <label style={{ fontSize: "14px" }}>Property<i style={{ color: "red" }}>*</i></label>

              <Select
                isMulti
                name="Property"
                options={array2}
                defaultValue={propertyVal}
                onChange={handlePropertySelect}
                className="basic-multi-select"
                classNamePrefix="select"
                value={selectedPropertyValues}
              />
              <p className="mt-1"><span className="font-weight-bold">Note:-</span> Properties having less than 6 Channels can be selected </p>
            </div>
            <div className="field position-relative">
              <label style={{ fontSize: "14px" }}>Channel Name<i style={{ color: "red" }}>*</i></label>
              <input
                type="text"
                name="channelName"
                placeholder="Channel Name"
                onKeyDown={(e) => {
                  if (e.target.selectionStart === 0 && e.key === " ") {
                    e.preventDefault();
                  }
                }}
                onChange={(e) => {
                  onInputChange1(e)
                }}
                value={onClickData.channelName}
              />
            </div>
            <div className="field position-relative">
              <label style={{ fontSize: "14px" }}>Channel ID<i style={{ color: "red" }}>*</i></label>
              <input
                type="text"
                name="channelID"
                placeholder="Channel ID"
                onChange={(e) => {
                  if (e.target.value.match(/[^A-Za-z0-9]/)) {
                    return
                  }
                  onInputChange1(e)
                }}
                value={onClickData.channelID}
              />
            </div>
            <div className="field col-6" style={{ paddingRight: "3px" }}>
              <label>Channel Language</label>
              <select
                className="form-control"
                value={onClickData.channel_language}
                name="channel_language"
                onChange={(event) => handleC1(event)}
              >
                <option value="">Select Language</option>
                <option value="English">English</option>
                <option value="Spanish">Spanish</option>
                <option value="Portuguese">Portuguese</option>
                <option value="French">French</option>
                <option value="Dutch">Dutch</option>
              </select>
            </div>
            <div className="field col-6" style={{ paddingLeft: "3px" }}>
              <label>Channel Category</label>
              <select
                className="form-control"
                value={onClickData.channel_category}
                name="channel_category"
                onChange={(event) => handleC(event)}
              >
                <option value="">Select Category</option>
                {/* <option hidden={hide} value="Bulletin Board">Bulletin Board</option> */}
                <option value="Bulletin Board">Bulletin Board</option>
                <option value="Live">Live</option>
                <option value="Security">Security</option>
                <option value="VOD">VOD</option>
                <option value="Schedules">Schedules</option>
                <option value="Activities">Activities</option>
              </select>
            </div>
            <div className="field">
              <label style={{ fontSize: "14px" }}>Channel Description </label>
              <textarea
                type="text"
                name="channelDescription"
                placeholder="Channel Description"
                onChange={(e) => onInputChange1(e)}
                value={onClickData.channelDescription}
              />
            </div>

            <div className="field col-6">
              <label style={{ fontSize: "14px" }}>Icon</label>

              <div class="input-group row">
                <div classNmae="input-group-prepend"></div>
                <div className="custom-file col-8">

                  <input
                    type="file"
                    id="myfile"
                    name="myfile"
                    accept="image/*"
                    onChange={(e) => getFile(e)}
                  />
                </div>
                <div className="col-4">
                  {onClickData.programIcon != "" ? (
                    <img
                      src={onClickData.programIcon}
                      style={{ height: "auto", width: "60%" }}
                      alt="image"
                    />
                  ) : (
                    <img
                      src={iconImage}
                      style={{ height: "auto", width: "60%" }}
                      alt="image"
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="field col-6">
              <label style={{ fontSize: "14px" }}>Video Source<i style={{ color: "red" }}>*</i></label>
              <div className="form-check form-check-inline">
                <input
                  type="radio"
                  className="form-check-input radio-button"
                  id="1"
                  value="billboard"
                  name="videoSource"
                  onChange={(event) => ischecked(event)}
                  checked={
                    onClickData.videoSource &&
                      onClickData.videoSource[0] === "billboard"
                      ? true
                      : false
                  }
                />
                <label className="form-check-label">Billboard</label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  type="radio"
                  className="form-check-input radio-button"
                  id="2"
                  value="encoder"
                  name="videoSource"
                  onChange={(e) => ischecked(e)}
                  checked={
                    onClickData.videoSource &&
                      onClickData.videoSource[0] === "encoder"
                      ? true
                      : false
                  }
                />
                <label className="form-check-label">Encoder</label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  type="radio"
                  className="form-check-input radio-button"
                  id="3"
                  value="url"
                  name="videoSource"
                  onChange={(e) => ischecked(e)}
                  checked={
                    onClickData.videoSource &&
                      onClickData.videoSource[0] === "url"
                      ? true
                      : false
                  }
                />
                <label
                  className="form-check-label"
                  style={{ paddingBottom: "15px" }}
                >
                  URL
                </label>
              </div>

              {onClickData.videoSource &&
                onClickData.videoSource[0] === "encoder" ? (
                <div>
                  <input
                    type="text"
                    name="encoder"
                    value={onClickData.videoSource[1]}
                    placeholder="Encoder"
                    onChange={(event) => {
                      let ChannelData = { ...onClickData };
                      ChannelData.videoSource[1] = event.target.value;
                      setOnclickData(ChannelData);
                    }}
                  ></input>
                </div>
              ) : (
                " "
              )}
              {onClickData.videoSource &&
                onClickData.videoSource[0] === "url" ? (
                <div className="dropdown">
                  <input
                    type="text"
                    placeholder="Url"
                    name="url"
                    value={onClickData.videoSource[1]}
                    onChange={(event) => {
                      let ChannelData = { ...onClickData };
                      ChannelData.videoSource[1] = event.target.value;
                      setOnclickData(ChannelData);
                    }}
                  ></input>
                </div>
              ) : (
                " "
              )}
            </div>
            {/* // for multiple billboard  */}
            <div
              hidden={
                onClickData.videoSource &&
                onClickData.videoSource[0] == "encoder"
                || onClickData.videoSource &&
                onClickData.videoSource[0] == "url"
              }
              className="row"
              style={{ marginTop: "25px", marginBottom: "10px" }}
            >
              <div className="col-11 program-header">
                <b>Billboards</b>
              </div>
              <div
                className="col-1 text-right"
                style={{
                  color: "#337ab7",
                  fontSize: "large",
                  fontWeight: "bold",
                  marginBottom: "10px",
                  cursor: "pointer",
                }}
              >
                <span onClick={(event) => {
                  addbillboard();
                }}>Add{" "}
                  <FontAwesomeIcon
                    className="icon"
                    icon={faPlusSquare}
                    style={{ paddingleft: "5px" }}
                  />
                </span>
              </div>
              {onClickData &&
                onClickData.billboard &&
                onClickData.billboard.map((elem, i) => {
                  return (
                    <div
                      className="row"
                      style={{ backgroundColor: "#f2f2f2", padding: "9px 5px" }}
                    >
                      <div className="col-2" style={{ padding: "2px", marginTop: "-8px" }}>
                        <label>
                          <b>Starts At</b>
                        </label>

                        <input
                          type="time"
                          format="HH:mm"
                          name="ProgramSchedule"
                          onChange={(event) => handlebillboardstarttime(event.target.value, i)}
                          value={elem.startTime} />

                      </div>

                      <div className="col-2" style={{ padding: "2px", marginTop: "-8px" }}>
                        <label>
                          <b>Ends At</b>
                        </label>

                        <input
                          type="time"
                          format="HH:mm"
                          name="ProgramSchedule"
                          onChange={(event) => handlebillboardendtime(event.target.value, i)}
                          value={elem.endTime} />
                      </div>

                      <div className="col-3" style={{ padding: "5px", marginTop: "-10px" }}>
                        <label>
                          <b>Timezone</b>
                        </label>
                        <select
                          onChange={(event) => {
                            handletimezoneChange(event.target.value, i, "Timezone");
                          }}
                          className="form-control"
                          value={onClickData.billboard[i].Timezone}
                        >
                          {timeZone.map(element => <option value={element.value}>{element.label}</option>
                          )}
                        </select>
                      </div>

                      <div className="col-4" style={{ padding: "5px", marginTop: "-10px" }}>
                        <b>Choose Layout </b>
                        <input name={"layout" + i} type="radio" value="layout" id={"layout" + i} className="radio-button"
                          onChange={(event) => {
                            handlelayoutTypechange(event.target.value, i, "layoutType", "layout");
                          }}
                          checked={onClickData.billboard[i] && onClickData.billboard[i].layoutType ? onClickData.billboard[i].layoutType == "layout" ? true : false : false} />
                        <b style={{ paddingLeft: "15px" }}>Input Url </b>
                        <input name={"url" + i} type="radio" id={"url" + i} value="url" className="radio-button"
                          onChange={(event) => {
                            handlelayoutTypechange(event.target.value, i, "layoutType", "url");
                          }}
                          checked={onClickData.billboard[i] && onClickData.billboard[i].layoutType ? onClickData.billboard[i].layoutType == "url" ? true : false : false} />
                        <select
                          onChange={(event) => {
                            handleChangeBillboard(event.target, i, "billboard", "billboard_name");
                          }}
                          className="form-control"
                          value={`${elem.billboard_name} (${elem.billboard})`}
                          hidden={onClickData.billboard[i] && onClickData.billboard[i].layoutType ? onClickData.billboard[i].layoutType != "layout" : true}
                        >
                          <option value="">Choose Layout</option>
                          {array1.map((optelem) => {
                            return (
                              <option value={optelem.value}>{optelem.label}</option>
                            );
                          })}
                        </select>
                        <input
                          type="text"
                          placeholder="Layout Url"
                          name="url"
                          value={onClickData.billboard[i] && onClickData.billboard[i].billboard ? onClickData.billboard[i].billboard : ""}
                          hidden={onClickData.billboard[i] && onClickData.billboard[i].layoutType ? onClickData.billboard[i].layoutType != "url" : true}
                          onChange={(event) => {
                            handletimezoneChange(event.target.value, i, "billboard");
                          }}
                        ></input>
                      </div>

                      <div className="col text-center d-flex align-items-center" style={{ marginTop: "6px", marginLeft: "7px" }}>
                        <label>
                          <b></b>
                        </label>
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={(event) => {
                            event.preventDefault();
                            // Deletebillboarddata(i)
                            DeleteConfirmationDialog("billboard", "Are you sure want to delete this billboard?", event, i);

                          }}
                        >
                          <i className="trash icon me-0"></i>
                        </button>{" "}
                      </div>
                    </div>
                  );
                })}
            </div>
            <div
              hidden={
                onClickData.videoSource &&
                onClickData.videoSource[0] === "billboard"
              }
              className="row"
              style={{ marginTop: "25px", marginBottom: "10px" }}
            >
              <div className="col-11 program-header">
                <b>Programs</b>
              </div>
              <div
                className="col-1 text-right"

                style={{
                  color: "#337ab7",
                  fontSize: "large",
                  fontWeight: "bold",
                  marginBottom: "10px",
                  cursor: "pointer",
                }}
              >
                <span onClick={() => {
                  addprogram();
                }}>Add{" "}
                  <FontAwesomeIcon
                    className="icon"
                    icon={faPlusSquare}
                    style={{ paddingleft: "5px" }}
                  /></span>

              </div>

              {onClickData &&
                onClickData.program &&
                onClickData.program.map((elem, i) => {
                  return (
                    <div
                      className="row"
                      style={{ backgroundColor: "#f2f2f2", padding: "15px" }}
                    >
                      <div className="col-4" style={{ padding: "5px" }}>
                        <label>
                          <b>Title</b>
                        </label>
                        <input
                          name={`title_${i}`}
                          className="form-control"
                          placeholder="Title of Program"
                          onChange={(event) =>
                            handleChangeProgram(event.target.value, i, "title")
                          }
                          value={elem.title}
                        />
                      </div>

                      <div className="col-4" style={{ padding: "5px" }}>
                        <label>
                          <b>Language</b>
                        </label>
                        <select
                          className="form-control"
                          value={elem.language}
                          name={`programLanguage_${i}`}
                          onChange={(event) =>
                            handleChangeProgram(
                              event.target.value,
                              i,
                              "language"
                            )
                          }
                        >
                          <option value="">Select Language</option>
                          <option value="English">English</option>
                          <option value="Spanish">Spanish</option>
                          <option value="Portuguese">Portuguese</option>
                          <option value="French">French</option>
                          <option value="Dutch">Dutch</option>
                        </select>
                      </div>

                      <div className="col-4" style={{ padding: "5px" }}>
                        <label>
                          <b>Duration</b>
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          name={`duration_${i}`}
                          placeholder="Duration"
                          value={elem.duration}
                          readOnly
                        />
                      </div>

                      <div className="col-2" style={{ padding: "5px" }}>
                        <label>
                          <b>Starts At</b>
                        </label>
                        <input
                          type="time"
                          format="HH:mm"
                          name="ProgramSchedule"
                          onChange={(event) =>
                            handleStartTime(event.target.value, i)
                          }
                          value={elem.startTime}
                        />
                      </div>

                      <div className="col-2" style={{ padding: "5px" }}>
                        <label>
                          <b>Ends At</b>
                        </label>
                        <input
                          type="time"
                          format="HH:mm"
                          name="ProgramSchedule"
                          onChange={(event) =>
                            handleEndTime(event.target.value, i)
                          }
                          value={elem.endTime}
                        />
                      </div>

                      <div className="col-8" style={{ padding: "5px" }}>
                        <label>
                          <b>Description</b>
                        </label>
                        <input
                          name={`programDescription_${i}`}
                          placeholder="Description"
                          onChange={(event) =>
                            handleChangeProgram(
                              event.target.value,
                              i,
                              "description"
                            )
                          }
                          value={elem.description}
                        />
                      </div>
                    </div>
                  );
                })}
            </div>
            <div></div>
          </form>
        </div>
        <Modal.Footer>
          <Button
            className="btn btn-success"
            onClick={() => {
              if (save) {
                saveProgram();
                setPropertyVal([]);
                setSelectedPropertyValues([]);
              } else {
                UpdateChannelinfo();
                setPropertyVal([]);
              }
            }}
          >
            {save ? "Save" : "Update"}
          </Button>
          <Button
            className="btn btn-danger"
            onClick={() => {
              setSelectedPropertyValues([]);
              setShow1(false);
            }}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal size="xl" show={show2} onHide={handleClose2}>
        <Modal.Header closeButton>
          <Modal.Title>Channel Statistics</Modal.Title>
        </Modal.Header>
        {
          Object.keys(dataStats).length > 0 ? <ChannelStats e={dataStats} /> : <div></div>
        }

      </Modal>
    </div >
  );
};

export default CloudDashboard;

function newFunction(columns, defaultColDef, allRuledata, gridOptions, onGridReady) {
  return <div className="form-boxdiv" style={{ marginTop: "15px" }}>
    <div className="form-boxtopline5">Channel Rule</div>
    <div className="form-boxtopcont user-form">
      <div
        className="ag-theme-alpine"
        style={{ height: "calc(70vh - 150px)" }}
      >
        <AgGridReact
          pagination={true}
          paginationPageSize={20}
          columnDefs={columns}
          defaultColDef={defaultColDef}
          enableBrowserTooltips={true}
          tooltipShowDelay={{ tooltipShowDelay: 0 }}
          rowData={allRuledata}
          gridOptions={gridOptions}
          gridReady={onGridReady}
          tooltipHideDelay={{ tooltipHideDelay: 100 }}

        ></AgGridReact>
      </div>
    </div>
  </div>;
}

export function TimeOverLaping(billboard) {
  let overLaping = [];
  billboard.forEach((e, i) => {
    if (overLaping.length > 0) return;
    let startTimeInInt = parseInt(e.startTime.replace(/[:]/g, ""));
    let endTimeInInt = parseInt(e.endTime.replace(/[:]/g, ""));
    overLaping = billboard.filter((ele, indx) => {
      if (i != indx) {
        let start = parseInt(ele.startTime.replace(/[:]/g, ""));
        let end = parseInt(ele.endTime.replace(/[:]/g, ""));
        return (
          (startTimeInInt > start && startTimeInInt < end) ||
          (endTimeInInt > start && endTimeInInt < end) ||
          startTimeInInt == start || endTimeInInt == end

        );
      }
      else return startTimeInInt >= endTimeInInt
    });
    if (overLaping.length > 0) {
      ErrorMessage(
        "Billboard's time is overlaping, Please ensure only one billboard is scheduled at a time."
      );
    }
  });
  return overLaping.length > 0;
}


